import {
  List as MuiList,
  ListProps,
  ListSubheader,
  Typography,
} from '@mui/material';
import { ClickableListItem } from './ClickableListItem';
import { StaticListItem } from './StaticListItem';
import React, { PropsWithChildren } from 'react';

export type ListItem = {
  primary: string;
  secondary?: string;

  primaryIcon?: React.ReactNode;
  secondaryIcon?: React.ReactNode;

  onClick?: () => void;
};

type Props = ListProps & {
  type: 'static' | 'selectable';
  items: ListItem[];
};

const List = ({
  type,
  items,
  subheader,
  children,
  ...props
}: PropsWithChildren<Props>) => {
  const ItemComponent = type === 'static' ? StaticListItem : ClickableListItem;

  return (
    <MuiList
      {...props}
      subheader={
        subheader ? (
          <ListSubheader
            disableGutters
            sx={(theme) => ({
              padding: `${theme.lelySpacing.SM} ${theme.lelySpacing.MD} ${theme.lelySpacing.XS} ${theme.lelySpacing.SM}`,
              lineHeight: 'normal',
            })}
          >
            <Typography variant="caption" color="text.secondary">
              {subheader}
            </Typography>
          </ListSubheader>
        ) : undefined
      }
    >
      {children && children}

      {!children &&
        items.map((item) => {
          return (
            <ItemComponent
              key={item.primary}
              {...item}
              data-testid={`list-item-${item.primary}`}
            />
          );
        })}
    </MuiList>
  );
};

export default List;
